<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">PPE Order</div>
                    <div class="pagebutton">
                        <router-link class="themebutton" title="Add PPE Order" v-bind:to="{name: 'AddUpdatePPEOrderSupplies'}">
                            <span>Add PPE Order</span>
                        </router-link>
                        <a class="themebutton" style="margin-right: 5px; color: white;" id='exportAllPPEOrederSuppliesData' title='Export' v-on:click.prevent="exportPPEOrderSuppliesData(1)">
                            <span>Export</span>
                        </a>
                    </div>
                </div>
                <div class="clearfix"></div>
                <vue-good-table
                    ref="ppeOrderSuppliesList"
                    mode="remote"
                    title="PPE Order"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :selectOptions="{
                        enabled: true,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        pageLabel: 'Page',
                        position: 'bottom',
                        perPage: serverParams.perPage,
                        setCurrentPage: serverParams.setCurrentPage,
                        perPageDropdown: [25, 50, 100, 200 ,500],
                        dropdownAllowAll: false,
                    }"
                    :search-options="{
                        enabled: false,
                    }">
                    <!-- Custome Pagination -->
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="vgt-wrap__footer crm">
                            <div  class="row">
                                <div class="col-sm-12 col-md-2 PerPage">
                                    <v-select title="Select Per Page"
                                        class="pagination-select-box"
                                        v-model="serverParams.perPage"
                                        @change="changedValueTask"
                                        @input="changedValueTaskCustomPerPageTask()"
                                        name="customPerPage"
                                        id="customPerPage"
                                        label="text"
                                        :clearable="false"
                                        :searchable="false"
                                        :filterable="false"
                                        :options="serverParams.perPageDropdown"
                                        placeholder="Select Per Page">
                                    </v-select>
                                </div>
                                <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                    <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                </div>
                                <div class="col-sm-12 col-md-6 Pagination">
                                    <ul class="pagination">
                                        <li class="FirstPage" title="First Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                            </template>
                                        </li>
                                        <li class="page-item PreviousPage" title="Previous Page">
                                            <template v-if="Number(serverParams.page) == 1">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                            </template>
                                        </li>
                                        <!--New Implementation-->
                                        <template v-if="pageNumberListTask() < displayPageTask">
                                            <template v-for="(n, index) in pageNumberListTask()">
                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <!--End New Implementation-->
                                            <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                <template v-for="(n, index) in displayPageTask">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                                        <li class="page-item NextPage" title="Next Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                            </template>
                                            <template v-else>
                                                <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                            </template>
                                        </li>
                                        <li class="LastPage" title="Last Page">
                                            <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                            </template>
                                            <template v-else>
                                                <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                                <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <p class="pageJumpLabel">Page : </p>
                                </div>
                                <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                    <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- End Custome Pagination -->
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class="table-action">
                                <router-link title='Edit PPE Order' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'UpdatePPEOrderSupplies', params:{id: props.row.id}}">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions" slot-scope="computed">
                        {{computed.selectedRows}}
                        <button id="exportPPEOrderIdData" v-on:click.prevent="exportPPEOrderSuppliesData(0)" class="btn btn-success" title="Export">
                            Export {{selectedRows}} Record(s)
                        </button>
                    </div>
                </vue-good-table>   
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../../mixins/commonMixins';
    import {HTTP} from '../../../http-common.js';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from "../../../components/event-bus";
    Vue.component("app-footer", Footer);
    Vue.use(VueGoodTable);
    var self;
    export default {
        name: 'ListPPEOrderSupplies',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                firstLoad: 0,
                columns: [
                    {
                        label: 'Requestor Name',
                        field: 'requestor_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Requestor Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Department',
                        field: 'department_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Department Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Location',
                        field: 'location_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Vendor',
                        field: 'vendor_name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Vendor", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            // placeholder: "MM/DD/YYYY",
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    }, */
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    perPageDropdown : [],
                },
                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                strExportPPEOrder: false,
            }
        },
        watch: {
        },
        created: function () {
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.menuActive("PPEOrderSupploes");
            self.jumpToPageTask = self.serverParams.page;
            self.pageCompareTask = Math.ceil(self.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });
            self.serverParams.perPageDropdown.push(25);
            self.serverParams.perPageDropdown.push(50);
            self.serverParams.perPageDropdown.push(100);
            self.serverParams.perPageDropdown.push(200);
            self.serverParams.perPageDropdown.push(500);
            self.loadPPEOrder();
        },
        methods: {
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadPPEOrder();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadPPEOrder();
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadPPEOrder();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({perPage: params.currentPerPage});
                    self.totalRecords = self.totalRecords;
                    self.loadPPEOrder();
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('id');
                    field: ('requestor_name');
                    field: ('department_name');
                    field: ('location_name');
                    field: ('vendor_name');
                    field: ('updated_at');
                    field: ('updated_by');
                };
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.id || filters.department_name || filters.requestor_name || filters.vendor_name
                    || filters.location_name || filters.updated_at || filters.updated_by
                ) {
                    self.loadPPEOrder();
                }
            },
            selectionChanged() {
                self.selectedRows = (self.$refs['ppeOrderSuppliesList'].selectedRows).length;
                /* console.log(self.selectedRows); */
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadPPEOrder();
            },
            loadPPEOrder() {
                self.firstLoad = 1;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                };
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    is_export: self.strExportPPEOrder
                };
                self.showLoader();
                HTTP.post("/ppe/order/list", fields, config)
                    .then(function (response) {
                        $('#exportAllPPEOrederSuppliesData').prop("disabled", false);
                        self.strExportPPEOrder = false;
                        if (response.data.code == '200') {
                            if (response.data.message == 'success export') {
                                location.href = response.data.content.web;
                                self.loadPPEOrder();
                            } else {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        $('#exportAllPPEOrederSuppliesData').prop("disabled", false);
                        self.strExportPPEOrder = false;
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            exportPPEOrderSuppliesData: function(allResersalDataExport) {
                if(allResersalDataExport) {
                    self.strExportPPEOrder = true;
                    if (self.strExportPPEOrder == true) {
                        $('#exportAllPPEOrederSuppliesData').prop("disabled", true);
                        self.loadPPEOrder();
                    }
                } else {
                    var ppeOrderArr = [];
                    var selectedUser = this.$refs["ppeOrderSuppliesList"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        ppeOrderArr.push(this.$refs["ppeOrderSuppliesList"].selectedRows[i].id);
                    }
                    $('#exportPPEOrderIdData').prop("disabled", true);
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("token")},
                    };
                    var fields = {
                        ppe_order_id: ppeOrderArr
                    };
                    self.showLoader();
                    HTTP.post("/ppe/order/export", fields, config)
                        .then(function (response) {
                            $('#exportPPEOrderIdData').prop("disabled", false);
                            if (response.data.code == '200') {
                                location.href = response.data.content.web;
                                self.loadPPEOrder();
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            $('#exportPPEOrderIdData').prop("disabled", false);
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
                }
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Forms/PPEOrderSupplies/ListPPEOrderSupplies.vue